import React from 'react'
import cx from 'classnames'
import styles from './ProgressBar.module.scss'

/**
 * A simple progress bar.
 * @param {Object} props
 * @param {string} [props.className] Additional classes
 * @param {number} props.progress Progress from 0 to 1 (cropped)
 */
const ProgressBar = ({ progress, className }) => {
    let validProgress = progress
    if (progress < 0) validProgress = 0
    if (progress > 1) validProgress = 1

    const classNames = cx({
        [styles.progressBar]: true,
        [className]: !!className,
    })

    return (
        <div className={classNames}>
            <div className={styles.progress} data-testid="progress-bar" style={{
                width: Math.round(validProgress * 100) + '%',
            }} />
        </div>
    )
}

export default ProgressBar
